/*
  Royal Canin cart deal (Theme settings > Royal Canin cart deal)

  The price badge and size cards are refreshed by the theme when the shopper
  picks another size. The line inside the Add to cart button is not, so this
  copies it from the freshly rendered section on every variant change.
  Loaded from layout/theme.liquid only while the setting is on.
*/
(() => {
  const subscribe = () => {
    const pubsub = window.theme && window.theme.pubsub;
    if (!pubsub || !pubsub.PUB_SUB_EVENTS || !pubsub.PUB_SUB_EVENTS.variantChange) return false;

    pubsub.subscribe(pubsub.PUB_SUB_EVENTS.variantChange, (event) => {
      const data = event && event.data;
      if (!data || !data.parsedHTML) return;

      const id = `RcDealButton-${data.sectionId}-${data.productId}`;
      const destination = document.getElementById(id);
      if (!destination) return;

      // Quick view renders the product from another section, so fall back to the first line in the response.
      const source = data.parsedHTML.getElementById(id) || data.parsedHTML.querySelector('[id^="RcDealButton-"]');
      if (source) {
        destination.innerHTML = source.innerHTML;
        destination.hidden = source.hidden;
      } else {
        destination.innerHTML = '';
        destination.hidden = true;
      }
    });
    return true;
  };

  if (!subscribe()) {
    document.addEventListener('DOMContentLoaded', subscribe, { once: true });
  }
})();
